import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../client/layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';

/* Plugins */

import nuxt_plugin_appplugin_71ce0f8a from 'nuxt_plugin_appplugin_71ce0f8a'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_ca300d18 from 'nuxt_plugin_configplugin_ca300d18'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_plugin_e6e6ce04 from 'nuxt_plugin_plugin_e6e6ce04'; // Source: ../node_modules/@pinia/nuxt/dist/runtime/plugin.vue2 (mode: 'all')
import nuxt_plugin_nuxtmq_3ed9719f from 'nuxt_plugin_nuxtmq_3ed9719f'; // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_vuescrollto_fdbf485c from 'nuxt_plugin_vuescrollto_fdbf485c'; // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_portalvue_2ffd205c from 'nuxt_plugin_portalvue_2ffd205c'; // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_axios_0ff5aa57 from 'nuxt_plugin_axios_0ff5aa57'; // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_1a2ddcc4 from 'nuxt_plugin_pluginutils_1a2ddcc4'; // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_07ab6de2 from 'nuxt_plugin_pluginrouting_07ab6de2'; // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_e8625680 from 'nuxt_plugin_pluginmain_e8625680'; // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_capiplugin_6b7be75c from 'nuxt_plugin_capiplugin_6b7be75c'; // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_13ac98cd from 'nuxt_plugin_errorpluginserver_13ac98cd'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_auth_56c7c1ff from 'nuxt_plugin_auth_56c7c1ff'; // Source: ../client/plugins/auth (mode: 'all')
import nuxt_plugin_stores_3af3636e from 'nuxt_plugin_stores_3af3636e'; // Source: ../client/plugins/stores (mode: 'all')
import nuxt_plugin_i18n_56ca5e75 from 'nuxt_plugin_i18n_56ca5e75'; // Source: ../client/plugins/i18n (mode: 'all')
import nuxt_plugin_vuesocketio_69da48d8 from 'nuxt_plugin_vuesocketio_69da48d8'; // Source: ../client/plugins/vue-socket.io.js (mode: 'client')
import nuxt_plugin_directives_5f2656fc from 'nuxt_plugin_directives_5f2656fc'; // Source: ../client/plugins/directives.js (mode: 'client')
import nuxt_plugin_hints_c7f1b6fc from 'nuxt_plugin_hints_c7f1b6fc'; // Source: ../client/plugins/hints.js (mode: 'client')
import nuxt_plugin_csrf_56c8a2fb from 'nuxt_plugin_csrf_56c8a2fb'; // Source: ../client/plugins/csrf (mode: 'client')
import nuxt_plugin_touchactive_3689d2ab from 'nuxt_plugin_touchactive_3689d2ab'; // Source: ../client/plugins/touch-active (mode: 'client')
import nuxt_plugin_modality_62983890 from 'nuxt_plugin_modality_62983890'; // Source: ../client/plugins/modality (mode: 'client')
import nuxt_plugin_polyfills_d73145e6 from 'nuxt_plugin_polyfills_d73145e6'; // Source: ../client/plugins/polyfills (mode: 'all')
import nuxt_plugin_textarea_8ff4cfde from 'nuxt_plugin_textarea_8ff4cfde'; // Source: ../client/plugins/textarea (mode: 'all')
import nuxt_plugin_virtualscroller_6babae93 from 'nuxt_plugin_virtualscroller_6babae93'; // Source: ../client/plugins/virtual-scroller (mode: 'all')
import nuxt_plugin_timeformat_d36977ca from 'nuxt_plugin_timeformat_d36977ca'; // Source: ../client/plugins/timeformat (mode: 'all')
import nuxt_plugin_link_56cc9451 from 'nuxt_plugin_link_56cc9451'; // Source: ../client/plugins/link (mode: 'all')
import nuxt_plugin_globals_346acd0e from 'nuxt_plugin_globals_346acd0e'; // Source: ../client/plugins/globals (mode: 'all')
import nuxt_plugin_validation_44444f90 from 'nuxt_plugin_validation_44444f90'; // Source: ../client/plugins/validation (mode: 'all')
import nuxt_plugin_axios_fb9c9a02 from 'nuxt_plugin_axios_fb9c9a02'; // Source: ../client/plugins/axios (mode: 'all')
import nuxt_plugin_pixel_fa030de2 from 'nuxt_plugin_pixel_fa030de2'; // Source: ../client/plugins/pixel (mode: 'client')
import nuxt_plugin_swregister_24e13222 from 'nuxt_plugin_swregister_24e13222'; // Source: ../client/plugins/sw-register.js (mode: 'client')
import nuxt_plugin_analytics_60d673f0 from 'nuxt_plugin_analytics_60d673f0'; // Source: ../client/plugins/analytics.js (mode: 'client')
import nuxt_plugin_hotjar_7f99c692 from 'nuxt_plugin_hotjar_7f99c692'; // Source: ../client/plugins/hotjar.js (mode: 'client')
import nuxt_plugin_helpcrunch_aa4e9176 from 'nuxt_plugin_helpcrunch_aa4e9176'; // Source: ../client/plugins/helpcrunch (mode: 'all')
import nuxt_plugin_lastCasesPage_31518c05 from 'nuxt_plugin_lastCasesPage_31518c05'; // Source: ../client/plugins/lastCasesPage (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly);

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render: function render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }
    return NoSsr.render(h, ctx);
  }
}));

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild);

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get: function get() {
    var globalNuxt = this.$root ? this.$root.$options.$nuxt : null;
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt;
    }
    return globalNuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "out-in",
  "appear": false,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
function createApp(_x) {
  return _createApp.apply(this, arguments);
}
function _createApp() {
  _createApp = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(ssrContext) {
    var config,
      store,
      router,
      app,
      next,
      route,
      path,
      inject,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          inject = function _inject(key, value) {
            if (!key) {
              throw new Error('inject(key, value) has no key provided');
            }
            if (value === undefined) {
              throw new Error("inject('".concat(key, "', value) has no value provided"));
            }
            key = '$' + key;
            // Add into app
            app[key] = value;
            // Add into context
            if (!app.context[key]) {
              app.context[key] = value;
            }

            // Check if plugin not already installed
            var installKey = '__nuxt_' + key + '_installed__';
            if (Vue[installKey]) {
              return;
            }
            Vue[installKey] = true;
            // Call Vue.use() to install the plugin into vm
            Vue.use(function () {
              if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
                Object.defineProperty(Vue.prototype, key, {
                  get: function get() {
                    return this.$root.$options[key];
                  }
                });
              }
            });
          };
          config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          store = null;
          _context2.next = 5;
          return createRouter(ssrContext, config, {
            store: store
          });
        case 5:
          router = _context2.sent;
          // Create Root instance
          // here we inject the router and store to all child components,
          // making them available everywhere as `this.$router` and `this.$store`.
          app = _objectSpread({
            head: {
              "meta": [],
              "link": [],
              "style": [],
              "script": []
            },
            router: router,
            nuxt: {
              defaultTransition: defaultTransition,
              transitions: [defaultTransition],
              setTransitions: function setTransitions(transitions) {
                if (!Array.isArray(transitions)) {
                  transitions = [transitions];
                }
                transitions = transitions.map(function (transition) {
                  if (!transition) {
                    transition = defaultTransition;
                  } else if (typeof transition === 'string') {
                    transition = Object.assign({}, defaultTransition, {
                      name: transition
                    });
                  } else {
                    transition = Object.assign({}, defaultTransition, transition);
                  }
                  return transition;
                });
                this.$options.nuxt.transitions = transitions;
                return transitions;
              },
              err: null,
              errPageReady: false,
              dateErr: null,
              error: function error(err) {
                err = err || null;
                app.context._errored = Boolean(err);
                err = err ? normalizeError(err) : null;
                var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
                if (this) {
                  nuxt = this.nuxt || this.$options.nuxt;
                }
                nuxt.dateErr = Date.now();
                nuxt.err = err;
                nuxt.errPageReady = false;
                // Used in src/server.js
                if (ssrContext) {
                  ssrContext.nuxt.error = err;
                }
                return err;
              }
            }
          }, App);
          next = ssrContext ? ssrContext.next : function (location) {
            return app.router.push(location);
          }; // Resolve route
          if (ssrContext) {
            route = router.resolve(ssrContext.url).route;
          } else {
            path = getLocation(router.options.base, router.options.mode);
            route = router.resolve(path).route;
          }

          // Set context to app.context
          _context2.next = 11;
          return setContext(app, {
            route: route,
            next: next,
            error: app.nuxt.error.bind(app),
            payload: ssrContext ? ssrContext.payload : undefined,
            req: ssrContext ? ssrContext.req : undefined,
            res: ssrContext ? ssrContext.res : undefined,
            beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
            beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
            ssrContext: ssrContext
          });
        case 11:
          // Inject runtime config as $config
          inject('config', config);

          // Add enablePreview(previewData = {}) in context for plugins
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              app.previewData = Object.assign({}, previewData);
              inject('preview', previewData);
            };
          }
          // Plugin execution
          if (!(typeof nuxt_plugin_appplugin_71ce0f8a === 'function')) {
            _context2.next = 16;
            break;
          }
          _context2.next = 16;
          return nuxt_plugin_appplugin_71ce0f8a(app.context, inject);
        case 16:
          if (!(typeof nuxt_plugin_configplugin_ca300d18 === 'function')) {
            _context2.next = 19;
            break;
          }
          _context2.next = 19;
          return nuxt_plugin_configplugin_ca300d18(app.context, inject);
        case 19:
          if (!(typeof nuxt_plugin_plugin_e6e6ce04 === 'function')) {
            _context2.next = 22;
            break;
          }
          _context2.next = 22;
          return nuxt_plugin_plugin_e6e6ce04(app.context, inject);
        case 22:
          if (!(typeof nuxt_plugin_nuxtmq_3ed9719f === 'function')) {
            _context2.next = 25;
            break;
          }
          _context2.next = 25;
          return nuxt_plugin_nuxtmq_3ed9719f(app.context, inject);
        case 25:
          if (!(process.client && typeof nuxt_plugin_vuescrollto_fdbf485c === 'function')) {
            _context2.next = 28;
            break;
          }
          _context2.next = 28;
          return nuxt_plugin_vuescrollto_fdbf485c(app.context, inject);
        case 28:
          if (!(typeof nuxt_plugin_portalvue_2ffd205c === 'function')) {
            _context2.next = 31;
            break;
          }
          _context2.next = 31;
          return nuxt_plugin_portalvue_2ffd205c(app.context, inject);
        case 31:
          if (!(typeof nuxt_plugin_axios_0ff5aa57 === 'function')) {
            _context2.next = 34;
            break;
          }
          _context2.next = 34;
          return nuxt_plugin_axios_0ff5aa57(app.context, inject);
        case 34:
          if (!(typeof nuxt_plugin_pluginutils_1a2ddcc4 === 'function')) {
            _context2.next = 37;
            break;
          }
          _context2.next = 37;
          return nuxt_plugin_pluginutils_1a2ddcc4(app.context, inject);
        case 37:
          if (!(typeof nuxt_plugin_pluginrouting_07ab6de2 === 'function')) {
            _context2.next = 40;
            break;
          }
          _context2.next = 40;
          return nuxt_plugin_pluginrouting_07ab6de2(app.context, inject);
        case 40:
          if (!(typeof nuxt_plugin_pluginmain_e8625680 === 'function')) {
            _context2.next = 43;
            break;
          }
          _context2.next = 43;
          return nuxt_plugin_pluginmain_e8625680(app.context, inject);
        case 43:
          if (!(typeof nuxt_plugin_capiplugin_6b7be75c === 'function')) {
            _context2.next = 46;
            break;
          }
          _context2.next = 46;
          return nuxt_plugin_capiplugin_6b7be75c(app.context, inject);
        case 46:
          if (!(process.server && typeof nuxt_plugin_errorpluginserver_13ac98cd === 'function')) {
            _context2.next = 49;
            break;
          }
          _context2.next = 49;
          return nuxt_plugin_errorpluginserver_13ac98cd(app.context, inject);
        case 49:
          if (!(typeof nuxt_plugin_auth_56c7c1ff === 'function')) {
            _context2.next = 52;
            break;
          }
          _context2.next = 52;
          return nuxt_plugin_auth_56c7c1ff(app.context, inject);
        case 52:
          if (!(typeof nuxt_plugin_stores_3af3636e === 'function')) {
            _context2.next = 55;
            break;
          }
          _context2.next = 55;
          return nuxt_plugin_stores_3af3636e(app.context, inject);
        case 55:
          if (!(typeof nuxt_plugin_i18n_56ca5e75 === 'function')) {
            _context2.next = 58;
            break;
          }
          _context2.next = 58;
          return nuxt_plugin_i18n_56ca5e75(app.context, inject);
        case 58:
          if (!(process.client && typeof nuxt_plugin_vuesocketio_69da48d8 === 'function')) {
            _context2.next = 61;
            break;
          }
          _context2.next = 61;
          return nuxt_plugin_vuesocketio_69da48d8(app.context, inject);
        case 61:
          if (!(process.client && typeof nuxt_plugin_directives_5f2656fc === 'function')) {
            _context2.next = 64;
            break;
          }
          _context2.next = 64;
          return nuxt_plugin_directives_5f2656fc(app.context, inject);
        case 64:
          if (!(process.client && typeof nuxt_plugin_hints_c7f1b6fc === 'function')) {
            _context2.next = 67;
            break;
          }
          _context2.next = 67;
          return nuxt_plugin_hints_c7f1b6fc(app.context, inject);
        case 67:
          if (!(process.client && typeof nuxt_plugin_csrf_56c8a2fb === 'function')) {
            _context2.next = 70;
            break;
          }
          _context2.next = 70;
          return nuxt_plugin_csrf_56c8a2fb(app.context, inject);
        case 70:
          if (!(process.client && typeof nuxt_plugin_touchactive_3689d2ab === 'function')) {
            _context2.next = 73;
            break;
          }
          _context2.next = 73;
          return nuxt_plugin_touchactive_3689d2ab(app.context, inject);
        case 73:
          if (!(process.client && typeof nuxt_plugin_modality_62983890 === 'function')) {
            _context2.next = 76;
            break;
          }
          _context2.next = 76;
          return nuxt_plugin_modality_62983890(app.context, inject);
        case 76:
          if (!(typeof nuxt_plugin_polyfills_d73145e6 === 'function')) {
            _context2.next = 79;
            break;
          }
          _context2.next = 79;
          return nuxt_plugin_polyfills_d73145e6(app.context, inject);
        case 79:
          if (!(typeof nuxt_plugin_textarea_8ff4cfde === 'function')) {
            _context2.next = 82;
            break;
          }
          _context2.next = 82;
          return nuxt_plugin_textarea_8ff4cfde(app.context, inject);
        case 82:
          if (!(typeof nuxt_plugin_virtualscroller_6babae93 === 'function')) {
            _context2.next = 85;
            break;
          }
          _context2.next = 85;
          return nuxt_plugin_virtualscroller_6babae93(app.context, inject);
        case 85:
          if (!(typeof nuxt_plugin_timeformat_d36977ca === 'function')) {
            _context2.next = 88;
            break;
          }
          _context2.next = 88;
          return nuxt_plugin_timeformat_d36977ca(app.context, inject);
        case 88:
          if (!(typeof nuxt_plugin_link_56cc9451 === 'function')) {
            _context2.next = 91;
            break;
          }
          _context2.next = 91;
          return nuxt_plugin_link_56cc9451(app.context, inject);
        case 91:
          if (!(typeof nuxt_plugin_globals_346acd0e === 'function')) {
            _context2.next = 94;
            break;
          }
          _context2.next = 94;
          return nuxt_plugin_globals_346acd0e(app.context, inject);
        case 94:
          if (!(typeof nuxt_plugin_validation_44444f90 === 'function')) {
            _context2.next = 97;
            break;
          }
          _context2.next = 97;
          return nuxt_plugin_validation_44444f90(app.context, inject);
        case 97:
          if (!(typeof nuxt_plugin_axios_fb9c9a02 === 'function')) {
            _context2.next = 100;
            break;
          }
          _context2.next = 100;
          return nuxt_plugin_axios_fb9c9a02(app.context, inject);
        case 100:
          if (!(process.client && typeof nuxt_plugin_pixel_fa030de2 === 'function')) {
            _context2.next = 103;
            break;
          }
          _context2.next = 103;
          return nuxt_plugin_pixel_fa030de2(app.context, inject);
        case 103:
          if (!(process.client && typeof nuxt_plugin_swregister_24e13222 === 'function')) {
            _context2.next = 106;
            break;
          }
          _context2.next = 106;
          return nuxt_plugin_swregister_24e13222(app.context, inject);
        case 106:
          if (!(process.client && typeof nuxt_plugin_analytics_60d673f0 === 'function')) {
            _context2.next = 109;
            break;
          }
          _context2.next = 109;
          return nuxt_plugin_analytics_60d673f0(app.context, inject);
        case 109:
          if (!(process.client && typeof nuxt_plugin_hotjar_7f99c692 === 'function')) {
            _context2.next = 112;
            break;
          }
          _context2.next = 112;
          return nuxt_plugin_hotjar_7f99c692(app.context, inject);
        case 112:
          if (!(typeof nuxt_plugin_helpcrunch_aa4e9176 === 'function')) {
            _context2.next = 115;
            break;
          }
          _context2.next = 115;
          return nuxt_plugin_helpcrunch_aa4e9176(app.context, inject);
        case 115:
          if (!(process.client && typeof nuxt_plugin_lastCasesPage_31518c05 === 'function')) {
            _context2.next = 118;
            break;
          }
          _context2.next = 118;
          return nuxt_plugin_lastCasesPage_31518c05(app.context, inject);
        case 118:
          // Lock enablePreview in context
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              console.warn('You cannot call enablePreview() outside a plugin.');
            };
          }

          // Wait for async component to be resolved first
          _context2.next = 121;
          return new Promise(function (resolve, reject) {
            // Ignore 404s rather than blindly replacing URL in browser
            if (process.client) {
              var _router$resolve = router.resolve(app.context.route.fullPath),
                _route = _router$resolve.route;
              if (!_route.matched.length) {
                return resolve();
              }
            }
            router.replace(app.context.route.fullPath, resolve, function (err) {
              // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
              if (!err._isRouter) return reject(err);
              if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve();

              // navigated to a different route in router guard
              var unregister = router.afterEach(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (process.server && ssrContext && ssrContext.url) {
                          ssrContext.url = to.fullPath;
                        }
                        _context.next = 3;
                        return getRouteData(to);
                      case 3:
                        app.context.route = _context.sent;
                        app.context.params = to.params || {};
                        app.context.query = to.query || {};
                        unregister();
                        resolve();
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            });
          });
        case 121:
          return _context2.abrupt("return", {
            app: app,
            router: router
          });
        case 122:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}
export { createApp, NuxtError };